import {useContext, useEffect, useState} from 'react'
import {SalesRepReportContext} from '../../context'
import {DynamicTable} from '../../../../components/DynamicTable'
import SalesRepReportRow from './SalesRepReportRow'
import {parseSalesRepReportRow} from '../../parsings'
import {formatCountAndPrice, keysToSum, SALES_REP_REPORT_COLUMNS} from '../../utils'
import {formatPrice, formatToIndianNumber} from '../../../../utils/common'

const SalesRepReportTable = () => {
  const {salesRepData, isSalesRepLoading, onSalesRepSortingChange, salesRepFilters} =
    useContext(SalesRepReportContext)
  const [summedState, setSummedState] = useState<any>({})

  useEffect(() => {
    const summed: any = {}
    salesRepData.forEach((row) => {
      keysToSum.forEach((key) => {
        const sumKey = `total_${key}`
        summed[sumKey] = (summed[sumKey] || 0) + (row[key] || 0)
      })
    })
    setSummedState(summed)
  }, [salesRepData])

  return (
    <DynamicTable
      data={salesRepData}
      sortableColumns={SALES_REP_REPORT_COLUMNS}
      loading={isSalesRepLoading}
      TableRow={SalesRepReportRow}
      noDataMessage='No sales rep reports found'
      onSortingChange={onSalesRepSortingChange}
      filters={salesRepFilters}
      tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'
      rowParsingFunction={parseSalesRepReportRow}
      tableFooter={({columnTotals}: any) => (
        <tfoot className='border-top border-gray-200 text-dark fw-bolder'>
          <tr>
            <td colSpan={3}>TOTAL</td>
            <td>{formatToIndianNumber(columnTotals.total_order_count)}</td>
            <td>
              {formatCountAndPrice(
                summedState?.total_freeship_coupon_count,
                summedState?.total_freeship_discount
              )}
            </td>
            <td>
              {formatCountAndPrice(
                summedState?.total_sf_coupon_count,
                summedState?.total_sf_discount
              )}
            </td>
            <td>
              {formatCountAndPrice(
                summedState?.total_sll_coupon_count,
                summedState?.total_sll_discount
              )}
            </td>
            <td>
              {formatCountAndPrice(
                summedState?.total_5offoneorder_coupon_count,
                summedState?.total_5offoneorder_discount
              )}
            </td>
            <td>
              {formatCountAndPrice(
                summedState?.total_other_coupon_count,
                summedState?.total_other_discount
              )}
            </td>
            <td>{formatPrice(columnTotals.total_discount, false)}</td>
          </tr>
        </tfoot>
      )}
    />
  )
}

export default SalesRepReportTable
